/**
 * Audit Service
 *
 * API service for platform-wide activity log and session queries.
 */

import api, { type RequestOptions } from './api';

export interface ActivityQuery {
  page?: number;
  pageSize?: number;
  search?: string;
  tenantId?: string;
  userId?: string;
  resourceType?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface SessionQuery {
  page?: number;
  pageSize?: number;
  search?: string;
  tenantId?: string;
  status?: string;
}

const auditService = {
  listActivity: (params: ActivityQuery, options?: RequestOptions) =>
    api.get('/activity', { params, ...options }),

  exportActivity: async (params: Omit<ActivityQuery, 'page' | 'pageSize'>) => {
    const response = await api.get('/activity/export', {
      params,
      responseType: 'blob',
    } as any);
    return response;
  },

  listSessions: (params: SessionQuery, options?: RequestOptions) =>
    api.get('/activity/sessions', { params, ...options }),

  exportSessions: async (params: Omit<SessionQuery, 'page' | 'pageSize'>) => {
    const response = await api.get('/activity/sessions/export', {
      params,
      responseType: 'blob',
    } as any);
    return response;
  },

  revokeSession: (id: string) =>
    api.delete(`/activity/sessions/${id}`),
};

export default auditService;
